import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import AppWalletProvider from "./WalletProvider";
import { ErrorBoundary } from "./shared/components";
import { performanceMonitor } from "./utils/performance";
import logger from "./utils/logger";

// Suppress browser extension runtime.lastError warnings (harmless extension errors)
if (typeof window !== 'undefined') {
  const originalError = console.error;
  console.error = function(...args) {
    const message = args[0];
    if (typeof message === 'string' && message.includes('runtime.lastError') && message.includes('Receiving end does not exist')) {
      return;
    }
    originalError.apply(console, args);
  };
  
  // Log app initialization
  logger.info('Application initializing');
}

// Mark app start
performanceMonitor.mark('app-start', 'Application start');

// Hide static HTML content when React mounts (static HTML is only for non-React fallback)
const hideStaticContent = () => {
  // Hide all static content except #root
  const allStatic = Array.from(document.body.children).filter(el => el.id !== 'root');
  allStatic.forEach(el => {
    // Keep script tags but hide visual elements
    if (el.tagName !== 'SCRIPT') {
      el.style.display = 'none';
    }
  });
};

const root = createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <AppWalletProvider>
      <App />
    </AppWalletProvider>
  </ErrorBoundary>
);

// Hide static content after React mounts
setTimeout(hideStaticContent, 0);

// Mark React mounted
performanceMonitor.mark('react-mounted', 'React mounted');
performanceMonitor.measure('react-mount-time', 'app-start', 'react-mounted');
